import React, {useState} from "react";
import {Box, Button, Input, Menu, MenuButton, MenuItem, MenuList, Stack, Text, VStack} from "@chakra-ui/react";
import {ChevronDownIcon} from "@chakra-ui/icons";
import {DropdownSelector} from "../../atoms/DropdownSelector";
import {TrashIcon} from "@heroicons/react/outline";
import {DatabaseInfo, DatabaseProperty} from "@app/core-app/app/data/notion/DatabaseInfo";
import {EXTRACTION_PROPERTIES_CONSTANTS} from "../../../../constants/extraction-properties";
import {event} from "../../../../services/analytics";
import {NotionPropertiesService} from "@app/core-app/app/service/notion-properties";
export const CreateNewAIProperty = ({onCreateNewAIProperty, database}: {
    onCreateNewAIProperty: any,
    database: DatabaseInfo
}) => {
  const [showForm, setShowForm] = useState(false);
  const [formType, setFormType] = useState("");
  const [selectedProperty, setSelectedProperty] = useState<string | null>(null);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false)
  const handleCreateClick = () => {
    setShowForm(true);
    setFormType("create");
  };

  const handleConnectClick = () => {
    setShowForm(true);
    setFormType("connect");
  };

  const handleTrashClick = () => {
    setShowForm(false);
    setFormType("");
    setSelectedProperty(null);
    setName("");
    setDescription("");
  };

  const handleAddClick = () => {
    const propertyId = database.propertiesObjects.find((p: DatabaseProperty) => p.name === selectedProperty)?.id

    const propertyInfo = {
      propertyId: propertyId,
      propertyName: formType === "create" ? name : selectedProperty,
      propertyDescription: description,
      isNew: formType === "create",
    };

    // console.log(propertyInfo);
    if (onCreateNewAIProperty) {
      setLoading(true)
      onCreateNewAIProperty(propertyInfo)
        .finally(() => {
          setLoading(false)
          handleTrashClick()
        })
    }
    // You can use this property info as per your requirement
  };

  const reservedProperties = [
    database.inboxReport.attachmentsProperty,
    database.inboxReport.toProperty,
    database.inboxReport.fromProperty,
    database.inboxReport.dateReceivedProperty,
    database.inboxReport.nameProperty,
    database.inboxReport.emailImageProperty,
    database.inboxReport.previewImageProperty,
  ]
  const supportedProperties = database.propertiesObjects
    .filter((p: DatabaseProperty) => NotionPropertiesService.supportedUpdateFields.includes(p.type))
    .filter((p: DatabaseProperty) => !reservedProperties.includes(p))
    .map((p: DatabaseProperty) => p.name)

  return (
    <>
      {!showForm && (
        <Stack direction={{base: "column", md: "row"}}>
          <Button size={"sm"} colorScheme={"blue"} onClick={handleCreateClick} isLoading={loading}>
                        Create new property
          </Button>
          <Button size={"sm"} colorScheme={"blue"} variant="outline" onClick={handleConnectClick}
            isLoading={loading}>
                        Connect existing property
          </Button>
          <Menu>
            <MenuButton size={"sm"} colorScheme={"blue"} variant="outline" as={Button}
              rightIcon={<ChevronDownIcon/>} isLoading={loading}>
                            Try Popular Options
            </MenuButton>
            <MenuList>
              {EXTRACTION_PROPERTIES_CONSTANTS.map(({propertyName, description}) => {
                return (
                  <MenuItem key={propertyName} onClick={() => {
                    const propertyInfo = {
                      propertyName: propertyName,
                      propertyDescription: description,
                      isNew: true,
                    };

                    event({
                      action: "extraction_popular_option_click",
                      params: {
                        propertyName: propertyName,
                        description: description,
                      }
                    })

                    if (onCreateNewAIProperty) {
                      setLoading(true)
                      onCreateNewAIProperty(propertyInfo)
                        .finally(() => {
                          setLoading(false)
                          handleTrashClick()
                        })
                    }

                  }}>{propertyName}</MenuItem>
                )
              })}

            </MenuList>
          </Menu>
        </Stack>
      )}

      {showForm && formType === "create" && (
        <VStack alignItems={"start"}>
          <Text>Create new Notion property:</Text>
          <Stack direction={{base: "column", md: "row"}} alignItems={{base: "start", md: "end"}} my={2} spacing={5} >
            <Box w={"200px"} fontSize={"sm"}>
              <Text>Property Name:</Text>
              <Input placeholder={""} value={name} onChange={(e) => setName(e.target.value)}/>
            </Box>

            <Box fontSize={"sm"}>
              <Text>Property description:</Text>
              <Input placeholder={"Optional"} value={description}
                onChange={(e) => setDescription(e.target.value)}/>
            </Box>

            <Box>
              <Button size={"sm"} colorScheme={"blue"} onClick={handleAddClick} isLoading={loading}>
                                Create property
              </Button>
            </Box>
            <Button variant={"unstyled"} size={"xs"} onClick={handleTrashClick}>
              <TrashIcon width={16}/>
            </Button>
          </Stack>
        </VStack>
      )}

      {showForm && formType === "connect" && (
        <VStack alignItems={"start"}>
          <Text>Connect existing Notion property to extract data from email:</Text>
          <Stack direction={{base: "column", md: "row"}} alignItems={{base: "start", md: "end"}}  my={2} spacing={5}>
            <Box w={"200px"} fontSize={"sm"}>
              <Text>Notion Property:</Text>
              <DropdownSelector
                value={selectedProperty}
                options={supportedProperties}
                onChange={(dataObject) => setSelectedProperty(dataObject?.value)}
              />
            </Box>

            <Box fontSize={"sm"}>
              <Text>Property description:</Text>
              <Input placeholder={"Optional"} value={description}
                onChange={(e) => setDescription(e.target.value)}/>
            </Box>

            <Box>
              <Button size={"sm"} colorScheme={"blue"} onClick={handleAddClick} isLoading={loading}>
                                Add property
              </Button>
            </Box>
            <Button variant={"unstyled"} size={"xs"} onClick={handleTrashClick}>
              <TrashIcon width={16}/>
            </Button>
          </Stack>
        </VStack>
      )}
    </>
  );
};